import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { COMPANY } from "@/data/content";
import { Section, Overline, usePageTitle } from "@/components/site/ui-bits";

export default function About() {
  usePageTitle("À propos");
  return (
    <div data-testid="about-page">
      <section className="bg-gradient-to-b from-sky-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
          <Overline>À propos</Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 max-w-3xl">
            Une filiale du {COMPANY.group} dédiée à la propreté
          </h1>
          <p className="mt-6 text-base leading-relaxed text-slate-600 max-w-2xl">
            Equinoxe Propreté est le pôle propreté du {COMPANY.group}. Notre mission : vous offrir
            des espaces sains, lumineux et accueillants, que vous soyez un particulier, une entreprise
            ou une collectivité. Nous combinons rigueur, discrétion et proximité.
          </p>
          <a
            href="https://groupeequinoxe.fr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="group-link"
            className="mt-5 inline-flex items-center gap-2 text-[#0ea5e9] font-semibold hover:gap-3 transition-all"
          >
            En savoir plus sur le Groupe Equinoxe <ArrowRight size={18} />
          </a>
        </div>
      </section>

      <Section>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img src="https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwcmlzdGluZSUyMGJyaWdodCUyMGxpdmluZyUyMHJvb20lMjBzdW5saWdodHxlbnwwfHx8fDE3ODIzODY2NTh8MA&ixlib=rb-4.1.0&q=85" alt="Intérieur propre" className="rounded-3xl shadow-xl w-full object-cover aspect-[4/3]" />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-slate-900">Nos valeurs</h2>
            <ul className="mt-6 space-y-4">
              {[
                ["Clarté & transparence", "Des prestations claires et des tarifs lisibles, sans surprise."],
                ["Proximité locale", "Basés à Francoulès et Cazals, nous intervenons rapidement dans le Lot et les départements limitrophes."],
                ["Soin & discrétion", "Nous traitons vos espaces comme les nôtres, avec respect et minutie."],
                ["Polyvalence", "De l'intérieur aux espaces verts, jusqu'à l'entretien des sépultures."],
              ].map(([t, d]) => (
                <li key={t} className="flex gap-4">
                  <span className="mt-1 w-6 h-6 rounded-full bg-sky-100 text-[#0ea5e9] flex items-center justify-center flex-shrink-0"><Check size={15} /></span>
                  <div>
                    <p className="font-semibold text-slate-900">{t}</p>
                    <p className="text-sm text-slate-600">{d}</p>
                  </div>
                </li>
              ))}
            </ul>
            <Link to="/contact" className="mt-8 inline-flex items-center gap-2 bg-[#0ea5e9] hover:bg-[#0284c7] text-white px-7 py-3.5 rounded-full font-bold transition-colors">
              Travailler avec nous <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </Section>

      <section className="bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid sm:grid-cols-3 gap-8 text-center">
          {[["2", "adresses dans le Lot"], ["7", "domaines d'intervention"], ["24h/24", "joignables sur WhatsApp"]].map(([n, l]) => (
            <div key={l}>
              <p className="text-4xl font-bold text-[#0ea5e9]">{n}</p>
              <p className="mt-2 text-sm text-slate-600">{l}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
